export default class SplashScene extends Phaser.Scene {
    constructor() {
        super({ key: 'SplashScene' });
    }

    preload() {
        // Load assets for splash screen
        this.load.image('logo', 'images/logo.png');
    }

    create() {
        // Add the logo to the center of the screen
        const logo = this.add.image(this.scale.width / 2, this.scale.height / 2, 'logo');

        // (Optional) Add a fade-in animation
        this.tweens.add({
            targets: logo,
            alpha: { from: 0, to: 1 },
            duration: 1000,
            onComplete: () => {
                // Wait for a short duration and then transition to the next scene
                this.time.delayedCall(500, () => {
                    this.scene.start('MainMenu'); // Switch to the main game scene
                });
            }
        });
    }
}